import React, { useState, useEffect } from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
    Svg,
    Line
} from "@react-pdf/renderer";

import logo from '../../../images/logo.png';

const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white'
    },
    title: {
        marginLeft: 20,
        marginRight: 20,
        marginBottom: 10,
        marginTop: 10,
        flexDirection: 'row',
        width: 400,
    },
    section: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 5,
        marginBottom: 5,
        padding: 5,
        flexGrow: 1,
        flexDirection: 'row',
    },
    sectionCell: {
        display: 'flex',
        flexWrap: 'wrap',
        width: 250,
        fontSize: 9
    },
    lineTop : {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 20,
        display: 'flex', 
        height: 1, 
        backgroundColor: 'black'
    },
    line : {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 5,
        marginBottom: 5,
        display: 'flex', 
        height: 1, 
        backgroundColor: 'black'
    },
    container: {
        marginLeft: 20,
        marginRight: 20,
        padding : 5,
        display: 'flex',
        flexDirection: 'row',
    },
    cell: {
        display: 'flex',
        flexWrap: 'wrap',
        width: 100,
        fontSize: 9
    },
    cell2: {
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: 9
    },
    image: {
        height: 50,
        width: 180
    },
    watermark: {
        position: "absolute",
        display: "block",
        fontSize: 55,
        color: "#9e9e9e",
        opacity: 0.08,
    },
    qr: {
        height: 200,
        width: 200,
        position: "absolute",
        display: "block",
    },
});

var QRCode = require('qrcode')
export function PdfDocument(props) {

    const [qr, setQr] = useState(false)

    useEffect(() => {

        if(props.data.dataQr) {
            let canvas;
            // For QR Code
            canvas = document.createElement('canvas');
            const url = "https://pk21.bkkbn.go.id/asas/"+ props.data.dataQr
            QRCode.toCanvas(canvas, props.data.dataQr);
            const qr = canvas.toDataURL();
    
            setQr(qr)
        }

    }, [props])
    
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {/* <View style={{transform: rotate('25deg'), backgroundColor:'red'}}> */}
                        <Text style={styles.watermark}>
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                            BKKBN BKKBN BKKBN 
                        </Text>
                    {/* </View> */}

                    <View style={styles.lineTop} />
                        <View style={styles.title}>
                            <Image
                                style={styles.image}
                                source={logo}
                            />
                            <Text style={{fontWeight: "bold", padding: 10, fontSize: 12}}>REKAPITULASI HASIL PENDATAAN KELUARGA TAHUN 2021 <Text style={{fontSize:15}}>TINGKAT RT {props.data.rt}</Text></Text>
                        </View>

                    <View style={styles.line} />
                        <View style={styles.container}>
                            <Text style={styles.cell}>Dusun/RW</Text>
                            <Text style={styles.cell2}>: {props.data.rw}</Text>
                        </View>
                    <View style={styles.line} />
                        <View style={styles.container}>
                            <Text style={styles.cell}>Desa/Kelurahan</Text>
                            <Text style={styles.cell2}>: {props.data.kelurahan}</Text>
                        </View>
                    <View style={styles.line} />
                        <View style={styles.container}>
                            <Text style={styles.cell}>Kecamatan</Text>
                            <Text style={styles.cell2}>: {props.data.kecamatan}</Text>
                        </View>
                    <View style={styles.line} />
                        <View style={styles.container}>
                            <Text style={styles.cell}>Kabupaten/Kota</Text>
                            <Text style={styles.cell2}>: {props.data.kabupaten}</Text>
                        </View>
                    <View style={styles.line} />
                        <View style={styles.container}>
                            <Text style={styles.cell}>Provinsi</Text>
                            <Text style={styles.cell2}>: {props.data.provinsi}</Text>
                        </View>
                    
                    <View style={{marginTop: 10}} />
                    <View style={styles.lineTop} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>1. Jumlah Keluarga Yang Ada</Text>
                                <Text style={styles.cell2}>{props.data.yang_ada}</Text>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>4. Jumlah Keluarga Yang Belum Di Data</Text>
                                <Text style={styles.cell2}>{props.data.belum_didata}</Text>
                            </View>
                        </View>
                    <View style={styles.line} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>2. Jumlah Keluarga Yang Didata</Text>
                                <Text style={styles.cell2}>{props.data.didata}</Text>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>5. Jumlah Keluarga Yang Di Tolak</Text>
                                <Text style={styles.cell2}>{props.data.ditolak}</Text>
                            </View>
                        </View>
                    <View style={styles.line} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>3. Jumlah Keluarga Yang Tidak Dapat Ditemui</Text>
                                <Text style={styles.cell2}>{props.data.tidak_ditemui}</Text>
                            </View>
                            <View style={styles.section}>
                                <Text style={styles.sectionCell}>6. Jumlah Keluarga Yang Tidak Mampu Menjawab</Text>
                                <Text style={styles.cell2}>{props.data.tidak_jawab}</Text>
                            </View>
                        </View>

                    <View style={{marginTop: 10}} />
                    <View style={styles.lineTop} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={styles.section}>
                                <Text></Text>
                            </View>
                            <View style={[styles.section, {textAlign: 'center', marginRight:30}]}>
                                <Text style={{fontSize:12}}>{props.data.tgl_submit}</Text>
                            </View>
                        </View>

                    <View style={styles.lineTop} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={[styles.section, {flexDirection: 'column'}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}>DIBUAT OLEH:</Text>
                                <Text style={{fontSize: 9}}>Kader Pendata,</Text>
                            </View>
                            <View style={[styles.section, {flexDirection: 'column'}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}></Text>
                                <Text style={{fontSize: 9}}></Text>
                            </View>
                        </View>
                    <View style={{marginTop: 50}} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={[styles.section, {flexDirection: 'column', width:270}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}>{props.data.pendata}</Text>
                            </View>
                            <View style={[styles.section, {flexDirection: 'column', width:205}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}></Text>
                            </View>
                        </View>

                    <View style={styles.lineTop} />
                    <View style={{flexDirection: 'row'}}>
                            <View style={[styles.section, {flexDirection: 'column'}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}>SUDAH DIPERIKSA DAN DITERIMA DENGAN BAIK OLEH :</Text>
                                <Text style={{fontSize: 9}}>Supervisor</Text>
                            </View>
                            <View style={[styles.section, {flexDirection: 'column', marginTop: 10, marginRight: 200}]}>
                                <Image src={qr} style={styles.qr}/>
                            </View>
                        </View>
                        <View style={{marginTop: 100}} />
                        <View style={{flexDirection: 'row'}}>
                            <View style={[styles.section, {flexDirection: 'column'}]}>
                                <Text style={{fontSize:10, fontWeight: 'bold'}}>(................................................)</Text>
                            </View>
                        </View>
                </View>
                
            </Page>
        </Document>
    )
}